import { useState } from 'react';
import { CertificateCard } from './CertificateCard';
import { CertificateUploadDialog } from './CertificateUploadDialog';
import { useToast } from '@/components/ui/toast';
import { useCertificateMutations } from '@/features/certificates/hooks';
import type { UploadCertificatePayload } from '@/features/certificates/api';

interface Props {
  cnpjId: string;
  cnpjLabel: string;
}

export function CertificateSlot({ cnpjId, cnpjLabel }: Props) {
  const [open, setOpen] = useState(false);
  const { upload } = useCertificateMutations(cnpjId);
  const toast = useToast();

  const handleSubmit = async (payload: UploadCertificatePayload) => {
    const cert = await upload.mutateAsync(payload);
    toast.show({ title: 'Certificado validado.', variant: 'success' });
    return cert;
  };

  return (
    <>
      <CertificateCard
        cnpjId={cnpjId}
        cnpjLabel={cnpjLabel}
        onUpload={() => setOpen(true)}
      />
      <CertificateUploadDialog
        open={open}
        onOpenChange={setOpen}
        onSubmit={handleSubmit}
        isSubmitting={upload.isPending}
      />
    </>
  );
}
